import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=3222fc30"
import script from "./BackgroundImage.vue?vue&type=script&setup=true&lang=js"
export * from "./BackgroundImage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports